/**
 * lds-price-in-button.js
 *
 * Keeps the .price-in-button span inside the add-to-cart button in sync with
 * the selected variant. Dawn's VariantSelects wipes the button's child nodes
 * via textContent= upon every variant change; this script re-injects the
 * correct price by listening to PUB_SUB_EVENTS.variantChange, which fires
 * after the section rendering fetch has completed and carries the fresh HTML.
 *
 * Behaviour:
 *  - Available variant  → injects up-to-date price span from rendered section HTML.
 *  - Sold-out variant   → no price injected (button is disabled in rendered HTML).
 *  - Unavailable combo  → no variantChange published by Dawn; Dawn's own
 *                         setUnavailable() already cleared the button text.
 *
 * Requires: constants.js, pubsub.js loaded before this file in theme.liquid.
 * Zero modifications to Dawn core files.
 *
 * Loaded from: lds-buy-buttons-price.liquid (only when show_price_in_button is true).
 * Guard: window.__ldsInitPriceInButton prevents double-registration when the
 * snippet is rendered more than once on the same page (quick-add, multi-product).
 */

(function () {
  if (window.__ldsInitPriceInButton) return;
  window.__ldsInitPriceInButton = true;

  /**
   * Subscribes to variant changes and refreshes the .price-in-button span.
   *
   * @param {object} event                - PUB_SUB_EVENTS.variantChange payload.
   * @param {string} event.data.sectionId - Section being updated.
   * @param {Document} event.data.html    - Parsed section HTML from section rendering API.
   */
  function onVariantChange(event) {
    const { sectionId, html } = event.data;

    // Read the freshly rendered button from the section rendering response.
    // This is the source of truth for this section — scoped by sectionId,
    // safe even if multiple product sections/lightboxes are open on the page.
    const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
    if (!addButtonUpdated) return;

    // Only act on sections where the price-in-button feature is enabled
    if (!addButtonUpdated.classList.contains('button--with-price')) return;

    // Do not show a price when the variant is sold out
    if (addButtonUpdated.hasAttribute('disabled')) return;

    const priceSource = addButtonUpdated.querySelector('.price-in-button');
    if (!priceSource) return;

    // Clone the full structure (price__regular, price__sale, etc.) then strip
    // the compare-at (strikethrough) price and its label from the clone.
    const priceClone = priceSource.cloneNode(true);
    priceClone.querySelectorAll('.price__sale > span:has(s), .price__sale > .visually-hidden:first-child').forEach((el) => el.remove());

    // Update the live DOM button for this section
    const productFormEl = document.getElementById(`product-form-${sectionId}`);
    if (!productFormEl) return;

    const addButtonText = productFormEl.querySelector('[name="add"] > span');
    if (!addButtonText) return;

    // Always start clean — remove any leftover price span (e.g. from page load)
    addButtonText.querySelector('.price-in-button')?.remove();

    addButtonText.appendChild(priceClone);
  }

  function init() {
    subscribe(PUB_SUB_EVENTS.variantChange, onVariantChange);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
